import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../../../base.component';
import { StoreService } from '../../../../Services/store';

@Component({
	selector: 'address-compare',
	templateUrl: './address-compare.component.html',
	styleUrls: ['./address-compare.component.scss'],
})
export class AddressCompareComponent extends BaseComponent implements OnInit {
	addressOptions: FullAddress[];
	selectedAddress: FullAddress;
	addressFoundGTMData;
	addressEnteredGTMData;

	ngOnInit() {
		// if(document.getElementsByTagName("app-address-display-dr") && document.getElementsByTagName("app-address-display-dr")[0]){
		//   var elem=document.getElementsByTagName("app-address-display-dr")[0].parentElement.parentElement.parentElement;
		//   this.Renderer.setStyle(elem, "display", "none");
		// }
		this.addressOptions = this.control.options;
		this.selectedAddress = this.addressOptions[0];
		this.updateAddressInStore();
		this.storeService.updateData('Mpq3drAddressChanges', true, 'page');
	}

	updateAddressInStore(): void {
		this.storeService.updateData(`${this.control.name}.AddressLine1`, this.selectedAddress.address1, 'page');
		this.storeService.updateData(`${this.control.name}.City`, this.selectedAddress.city, 'page');
		this.storeService.updateData(`${this.control.name}.State`, this.selectedAddress.state, 'page');
		this.storeService.updateData(`${this.control.name}.ZipCode`, this.selectedAddress.zipCode, 'page');
		this.storeService.updateData(`${this.control.name}.County`, this.selectedAddress.county, 'page');

		this.storeService.updateData(`isAddressCompareActive`, true, 'page');
	}

	onAddressSelected(address: FullAddress): void {
		this.selectedAddress = address;
		this.updateAddressInStore();
	}
}
